module.exports = __webpack_public_path__ + "media/site_templates/www.hirecarpenters.com.au/images/our_services_2-f3de4c569254581e9c30b29e1238697f.jpg";